export const config = {
  prefix: process.env.VUE_APP_OSS_URL,
  baseURL: process.env.VUE_APP_API_HOST,
}
